module.exports = __webpack_public_path__ + "img/1555113058.ec1edfa7.jpg";